import React from 'react';
import { StarIcon } from 'lucide-react';
export function TrustBar() {
  return <div className="bg-brand-alt border-y border-brand-divider py-4 md:py-5" data-id="element-178">
      <div className="container px-4 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center" data-id="element-179">
        <div className="flex items-center gap-1 text-brand-gold" data-id="element-180">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-181" />)}
        </div>
        <p className="font-sans text-sm md:text-base text-brand-text/80 tracking-wide" data-id="element-182">
          <span className="font-medium text-brand-text" data-id="element-183">250+ Reviews</span> |
          4.9 Stars | San Ramon, CA
        </p>
      </div>
    </div>;
}